/*@flow*/
import type { Node } from 'react';
import React from 'react';
import { set } from 'ops';
import cx from 'classnames';
import Btn from './Btn';
import useGeolocate from '../lib/useGeolocate';
import useNewSidebarCommands from 'comps/Left2/useCommands';

const Component = (): Node => {
  const cmd = useNewSidebarCommands();
  const markerClass = 'fa-map-marker-alt text-primary';

  const map = window.cityMap || window.districtMap;

  const cb = (lng, lat) => {
    if (!map) return;
    const panOpts = { animate: false };
    map.panTo([lat, lng], panOpts);

    // Only for cityMap
    if (window.cityMap) {
      map.setZoom(18);
      // Activate curb layer
      set('$query.deck.Streetscape.Curbs', 'on');
    }
    // add a marker
    cmd.putMarkerAt(lat, lng);
  };
  const { isGeoLocating, geolocate } = useGeolocate(cb);

  return (
    <Btn
      title="Find your location"
      onClick={geolocate}
      className="btn btn-secondary"
      testid="GeolocateBtn"
    >
      <i
        className={cx('fa', {
          [markerClass]: !isGeoLocating,
          'fa-spinner fa-spin': isGeoLocating,
        })}
      />
    </Btn>
  );
};

export default Component;
